module.exports = __webpack_public_path__ + "img/Local-Clips-Option-1.48e833fe.png";